// src/context/AuthContext.js
import { createContext, useState, useContext } from 'react';

const AuthContext = createContext(null);

export const USUARIOS = [
  { usuario: 'admin', pin: '2107', rol: 'admin', nombre: 'Administrador' },
  { usuario: 'gaby', pin: '2828', rol: 'admin', nombre: 'Gabriela Chevez' },
];

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(
    JSON.parse(localStorage.getItem('zoler_usuario') || 'null')
  );

  const login = (u) => {
    setUsuario(u);
    localStorage.setItem('zoler_usuario', JSON.stringify(u));
  };

  const logout = () => {
    setUsuario(null);
    localStorage.removeItem('zoler_usuario');
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);